import styled from "styled-components";
import {styledByDevice} from "../../../themes/architecture/styled-by-device";
import {PcBox as PcBaseBox, MobileBox as MobileBaseBox} from "./language-switcher-dropdown.default.box";

const PcMrGreenBox = styled(PcBaseBox)`
    background: ${props => props.theme.colors.backgroundMiddleDark};
    &::after {
        border-bottom-color: ${props => props.theme.colors.backgroundMiddleDark};
    }
`;

const MobileMrGreenBox = styled(MobileBaseBox)`
    background: ${props => props.theme.colors.background};
`;

export const LanguageSwitcherDropdownMrGreenBox = styledByDevice(PcMrGreenBox, MobileMrGreenBox);